import { AskPCOSUserType, iPageContext } from "../../../types"

const isArticleBookmarked = (
  userProfile: AskPCOSUserType | null,
  pageContext: iPageContext,
  slugPrefix?: string
) => {
  if (!userProfile) return false
  if (userProfile.bookmarked_articles === null) return false
  return userProfile.bookmarked_articles.includes(
    `${slugPrefix || ""}${pageContext.data.slug}`
  )
}

export default isArticleBookmarked
